// Static hero carousel slides for the homepage.
// Note: All other data (projects, news, philosophy) has been migrated to MongoDB
// and is fetched via /api endpoints. See /app/backend/routes/projects.py.
export const heroSlides = [
  {
    id: 1,
    title: "Urbanisme résilient",
    title_en: "Resilient urbanism",
    description: "",
    description_en: "",
    image: "https://customer-assets.emergentagent.com/job_design-studio-mazaba/artifacts/wxzwcrrf_PierreLExcellent-BRUT_ne_pas_diffuser-130.JPG"
  },
  {
    id: 2,
    title: "Architecture écologique",
    title_en: "Ecological architecture",
    description: "Équipements publics, logements et aménagements urbains pensés pour l'avenir. Une vision contemporaine ancrée dans le territoire.",
    description_en: "Public facilities, housing and urban developments designed for the future. A contemporary vision rooted in the territory.",
    image: "https://customer-assets.emergentagent.com/job_design-studio-mazaba/artifacts/5e3tqahy_SYLVAINMAZABA_BONDY_HD-11.jpg"
  },
  {
    id: 3,
    title: "Plus qu'un projet passionné",
    title_en: "More than a passionate project",
    description: "",
    description_en: "",
    image: "https://customer-assets.emergentagent.com/job_design-studio-mazaba/artifacts/95w0ad5q_DSC_3456-2.jpg"
  }
];
